/* global google */

export default class GMap {
	constructor(map) {
		if (typeof google.maps !== 'object') { return; }

		this.mapEl = map;
		this.data = JSON.parse(this.mapEl.dataset.json);
		this.markers = [];
		this.settings = jQuery.extend({
			lat: 37.979561,
			lng: 23.728487,
			zoom: 13,
			styles: '',
			places_categories: false,
			locations: [{
				lat: 37.979561,
				lng: 23.728487,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, this.data);

		this.init();
	}

	hideAllInfoWindows() {
		Array.from(this.markers).forEach((marker) => {
			if (marker.infowindow) {
				marker.infowindow.close(this.GMap, marker);
			}
		});
	}

	setLocations() {
		if (this.settings.locations) {
			const gMap = this.GMap;
			const Markers = this.markers;
			const Bounds = this.bounds;
			const hideAllInfoWindows = this.hideAllInfoWindows.bind(this);


			for (const [key, value] of Object.entries(this.settings.locations)) {
				const loc = value;
				const locLatLng = new google.maps.LatLng(loc.lat, loc.lng);
				let infoButtonString = '';
				let infoImageUrl = '';
				let markerInfowindow = false;
				let icon = '';

				if (loc.info_btn_url) {
					infoButtonString = `<p><a href="${loc.info_btn_url}" target="${loc.info_btn_target}">${loc.info_btn}</a></p>`;
				}

				if (loc.image_src) {
					infoImageUrl = `<div class="side-gmap"><img src="${loc.image_src}" alt="${loc.image_alt}" /></div>`;
				}

				if (loc.marker_svg_file) {
					icon = {
						url: loc.marker_svg_file,
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(loc.marker_svg_size_width / 2, loc.marker_svg_size_height),
						scaledSize: new google.maps.Size(loc.marker_svg_size_width, loc.marker_svg_size_height),
					};
				}

				if (loc.info_text || loc.info_title) {
					const contentString = `<div class="map-infowindow">
						${infoImageUrl}
						<div class="main-gmap">
						<h3 class="text-dark">${loc.info_title}</h3>
						<div class="text-dark">${loc.info_text + infoButtonString}
						</div>
						</div>
						</div>`;

					markerInfowindow = new google.maps.InfoWindow({
						content: contentString
					});
				}

				const marker = new google.maps.Marker({
					position: locLatLng,
					map: gMap,
					icon,
					draggable: false,
					zIndex: -20,
					infowindow: markerInfowindow,
				});

				Markers.push(marker);

				marker.addListener('click', () => {
					hideAllInfoWindows();

					if (marker.infowindow) {
						marker.infowindow.open(marker.get('map'), marker);
					}

					gMap.panTo(marker.getPosition());
				});

				gMap.panTo(marker.getPosition());

				Bounds.extend(locLatLng);
			}
		}
	}

	init() {
		this.bounds = new google.maps.LatLngBounds();

		this.GMap = new google.maps.Map(this.mapEl, {
			// center: { lat: this.settings.lat, lng: this.settings.lng },
			zoom: this.settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: this.settings.styles ? this.settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		this.setLocations.bind(this)();

		this.GMap.setZoom(this.settings.zoom);

		if (this.settings.locations.length > 0) {
			this.GMap.fitBounds(this.bounds);
		}
	}
}
